import { render, staticRenderFns } from "./PorcentagemToleranciaDialog.vue?vue&type=template&id=1480b9bc"
import script from "./PorcentagemToleranciaDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./PorcentagemToleranciaDialog.vue?vue&type=script&setup=true&lang=js"
import style0 from "./PorcentagemToleranciaDialog.vue?vue&type=style&index=0&id=1480b9bc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports